// extracted by mini-css-extract-plugin
module.exports = {"breadCrumb":"BreadCrumb_breadCrumb_jnQa4","active":"BreadCrumb_active_1vdOS","symbol":"BreadCrumb_symbol_ke_AL"};